import '@mui/material/Chip';
import '@mui/material/Button';
import '@mui/material/Alert';

/**
 * MUI Type Augmentations for @evaneos/b2b-ui
 *
 * This file centralizes all Material-UI module augmentations to ensure
 * custom variants, colors, and theme extensions are properly exported
 * to consuming applications.
 */

declare module '@mui/material' {
    // Button custom colors
    interface ButtonPropsColorOverrides {
        contrasted: true;
        ai: true;
    }

    // Alert custom colors
    interface AlertPropsColorOverrides {
        ai: true;
    }

    // Chip custom variants
    interface ChipPropsVariantOverrides {
        rounded: true;
    }
}

declare module '@mui/material/styles' {
    interface TypographyVariants {
        titleMoretL: React.CSSProperties;
        titleMoretXL: React.CSSProperties;
    }

    // allow configuration using `createTheme()`
    interface TypographyVariantsOptions {
        titleMoretL?: React.CSSProperties;
        titleMoretXL?: React.CSSProperties;
    }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        titleMoretL: true;
        titleMoretXL: true;
    }
}

// Force this file to be treated as a module
export {};
